import { apiErrorMessage } from '../lib/apiError.ts'
/**
 * Foroba POST /auth/token answers HTTP 200 for BOTH a finished login (token pair)
 * and an MFA challenge ({ mfa_required: true }), so the status alone is not enough.
 */
export type TokenOutcome =
  | { kind: 'tokens'; access_token: string; refresh_token: string }
  | { kind: 'mfa'; methods: string[] | undefined }
  | { kind: 'error'; message: string }

interface TokenBody {
  access_token?: string
  refresh_token?: string
  mfa_required?: boolean
  methods?: string[]
  detail?: unknown
}

export function classifyTokenResponse(status: number, body: TokenBody): TokenOutcome {
  if (status !== 200) return { kind: 'error', message: apiErrorMessage(body, `Login failed (${status})`) }
  if (body.mfa_required) return { kind: 'mfa', methods: body.methods }
  if (body.access_token && body.refresh_token) {
    return { kind: 'tokens', access_token: body.access_token, refresh_token: body.refresh_token }
  }
  return { kind: 'error', message: 'Login failed (unexpected response)' }
}
